"use client";

import Link from "@/components/LocalizedLink";
import type { InsightTag } from "@/lib/insights/types";
import { useTranslation } from "@/lib/i18n";
import { makeTr } from "@/lib/tools-i18n";
import { INSIGHTS_BG, tagLabel } from "@/lib/tools-i18n/insights";

interface TagPillProps {
  tag: InsightTag;
  /** When true, renders as a link to /insights/tag/[tag]/. Default true. */
  asLink?: boolean;
  size?: "sm" | "md";
}

export function TagPill({ tag, asLink = true, size = "sm" }: TagPillProps) {
  const { language } = useTranslation();
  const tr = makeTr(language, INSIGHTS_BG);
  const label = tagLabel(tag, language);
  const padding = size === "sm" ? "px-2 py-0.5 text-xs" : "px-2.5 py-1 text-sm";
  const className = `inline-flex items-center rounded-md bg-accent/10 ${padding} font-medium text-accent-text hover:bg-accent/15 transition-colors`;
  if (!asLink) {
    return <span className={className}>{label}</span>;
  }
  return (
    <Link
      href={`/insights/tag/${tag}/`}
      className={className}
      aria-label={language === "bg" ? `${tr("View all insights tagged")} ${label}` : `View all ${label} insights`}
    >
      {label}
    </Link>
  );
}
